import { PackageInfo } from '../types'

export default function checkPlusPackChangeLangPossible(
  packageAndSticker: PackageInfo,
) {
  const passedSticker = packageAndSticker.emoticons.filter((sticker) =>
    sticker.stickerInspectionData
      ? sticker.stickerInspectionData.isPassed
      : false,
  )
  if (passedSticker.length > 0) {
    return false
  }
  return true
}
